// RULING 22 — sales invoice certification. The SHAPE lives in CertificationQueue; this file is only
// the configuration, so a change to how a certification queue behaves happens in one place and
// reaches both classes.
import React from 'react';
import CertificationQueue from './CertificationQueue';

const num = (v) => { const n = Number(v); return Number.isFinite(n) ? n : 0; };
const inr = (v) => '₹' + num(v).toLocaleString('en-IN', { maximumFractionDigits: 2 });
const fmtD = (d) => d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: '2-digit' }) : '—';

const CONFIG = {
  queueUrl: '/finance/sales-invoices/certification-queue',
  certifyUrl: (id) => `/finance/sales-invoices/${id}/certify`,
  title: '✅ Sales Invoice Certification',
  blurb: "Finance's verdict that the invoice states what was actually sold. Separate from whether the buyer has paid.",
  noun: 'invoice', aNoun: 'an invoice', nounPlural: 'invoices',
  lockNote: ' The invoice then becomes locked for editing (Lock D).',
  refOf: (r) => r.invoice_no, amountOf: (r) => r.total_amount,
  columns: [
    { key: 'inv', label: 'Invoice', render: (r) => (<>
        <div style={{ fontWeight: 600 }}>{r.invoice_no || <span style={{ color: '#aaa' }}>(no number)</span>}</div>
        {r.busy_invoice_no && <div style={{ fontSize: 11, color: '#888' }}>Busy {r.busy_invoice_no}</div>}
        {r.gpo_no && <div style={{ fontSize: 11, color: '#888' }}>{r.gpo_no}</div>}
      </>) },
    { key: 'date', label: 'Date', nowrap: true, render: (r) => fmtD(r.invoice_date) },
    // THE RAW BUYER TEXT, uncleaned. Where the master name and the typed name differ, the difference
    // is the signal — same reasoning as the allocation screen.
    { key: 'buyer', label: 'Buyer', render: (r) => (<>
        <div>{r.buyer_name || r.buyer_raw || '—'}</div>
        {r.buyer_raw && r.buyer_name && r.buyer_raw !== r.buyer_name && (
          <div style={{ fontSize: 11, color: '#9A6B00', fontFamily: 'monospace' }}>⚠ typed as “{r.buyer_raw}”</div>)}
        {!r.buyer_id && <div style={{ fontSize: 11, color: '#9B1C1C' }}>no buyer master</div>}
      </>) },
    { key: 'amt', label: 'Amount', right: true, render: (r) => (<>
        <div style={{ fontWeight: 600 }}>{inr(r.total_amount)}</div>
        <div style={{ fontSize: 11, color: '#888' }}>{num(r.qty)} pc</div>
      </>) },
  ],
  // The three edit locks are a sales-invoice fact. Shown so the screen can say why an edit would be
  // refused without reimplementing locks it does not own.
  extraColumns: [
    { key: 'locks', label: 'Locks', render: (r) => {
        const on = [r.lock_a_paid && 'A paid', r.lock_b_discounted && 'B discounted', r.lock_c_credit_note && 'C credit note'].filter(Boolean);
        return on.length ? on.map((l) => <div key={l} style={{ fontSize: 11, color: '#6B5418' }}>{l}</div>)
                         : <span style={{ color: '#bbb' }}>—</span>;
      } },
  ],
};

export default function SalesCertification() { return <CertificationQueue config={CONFIG} />; }
